import * as Yup from 'yup';

export const navList = [
  {
    display: 'Departures',
    slug: 'departures',
  },
  {
    display: 'Travel Details',
    slug: 'travel-details',
  },
  {
    display: 'Passenger Details',
    slug: 'passengers',
  },
  {
    display: 'Billing Details',
    slug: 'billing',
  },
  {
    display: 'Confirmation',
    slug: 'confirmation',
  },
];

export const initialTravelDetailsValues = {
  no_travellers: null,
  single_room: null,
  double_room: null,
  share: null,
  quote_international: null,
  international_details: '',
  extensions: null,
  extensions_details: '',
  honeypot: null,
};

export const initialPassengerValues = {
  lead_title: '',
  lead_first_name: '',
  lead_last_name: '',
  date_of_birth: '',
  sex: null,
  telephone: '',
  email: '',
  additional_passengers: [],
};

export const travelDetailsValidationSchema = Yup.object({
  no_travellers: Yup.mixed().notOneOf([null, undefined, false], '* Required'),
  single_room: Yup.mixed().notOneOf([null, undefined, false], '* Required'),
  double_room: Yup.mixed().notOneOf([null, undefined, false], '* Required'),
});

export const passengerValidationSchema = Yup.object({
  title: Yup.string().required('* required'),
  first_name: Yup.string().required('* required'),
  last_name: Yup.string().required('* required'),
});

export const singlePassengerInitialValues = {
  title: '',
  first_name: '',
  last_name: '',
};
